import { useReveal } from "@/hooks/useReveal";
import SpecTable, { type SpecRow } from "./SpecTable";

const SUGAR_ROWS: SpecRow[] = [
  { label: "HS code", value: "1701.13" },
  { label: "Presentation", value: "Pulverised · granulated" },
  { label: "Granulometry, pulverised", value: "Granules diameter less than 2,5 mm" },
  { label: "Granulometry, granulated", value: "Granules diameter less than 2,5 mm" },
  { label: "Moisture", value: "Max 5,0%" },
  { label: "Total sugars", value: "Max 93%" },
  { label: "Ash content", value: "Min 1%" },
  { label: "Colour", value: "Amber to dark amber, natural variation by harvest" },
  { label: "Additives", value: "None. No anti-caking agent, no colourant, no sulphur" },
  { label: "Microbiological profile", value: "Yeast and fungus count ufc/g: <150" },
  { label: "Heavy metals", value: "Lead expressed as Pb, mg/Kg : Máx. 0,2. Arsenic expressed as As, mg/Kg: Máx. 0,1. Sulphites expressed as SO2, mg/Kg: Absence. Colorants: Absence" },
  { label: "Allergens", value: "It has sucrose content, therefore it is not a product suitable for diabetics (Max. 90%)" },
  { label: "Shelf life", value: "The product lasts 24 months from the date of manufacture under normal storage conditions." },
  { label: "Bulk formats", value: "25 kg sack" },
];

const COCOA_ROWS: SpecRow[] = [
  { label: "HS code", value: "1805.00" },
  { label: "Fat content", value: "15%" },
  { label: "Process", value: "Natural" },
  { label: "Moisture", value: "Max 7,0" },
  { label: "Added sugar", value: "None" },
  { label: "Microbiological profile", value: "Salmonella Spp : Absence" },
  { label: "Heavy metals", value: "Lead determination: Negative" },
  { label: "Allergens", value: "May contain traces of soy, milk, gluten, peanuts and other nuts" },
  { label: "Shelf life", value: "Under normal storage conditions it lasts 24 months" },
  { label: "Bulk formats", value: "25 kg sack" },
];

export default function Specifications() {
  const headRef = useReveal<HTMLDivElement>();
  const tableRef = useReveal<HTMLDivElement>();

  return (
    <section id="specifications" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headRef} className="reveal max-w-[800px]">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Specifications
          </h2>
          <p className="mt-4 text-ink/70 text-lg leading-relaxed">
            Published in full. If the specification does not fit your
            formulation, you will know before you write to us.
          </p>
        </div>

        <div
          ref={tableRef}
          className="reveal mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12"
        >
          <SpecTable
            title="Organic whole cane sugar (non-centrifugal cane sugar)"
            rows={SUGAR_ROWS}
          />
          <SpecTable title="Organic cocoa powder" rows={COCOA_ROWS} />
        </div>

        <p className="mt-10 text-ink/70 text-lg leading-relaxed max-w-[800px]">
          Cocoa butter, cocoa nibs and cocoa shell are available on request. Ask
          for the specification if a line is relevant to your formulation.
        </p>

        <div className="mt-6 max-w-[800px] border border-brown/40 rounded-lg px-5 py-4">
          <p className="text-ink text-base leading-relaxed">
            Values are the standard specification. Tolerances can be tightened to
            an agreed range for a homologated supply agreement — tell us what your
            process needs.
          </p>
        </div>
      </div>
    </section>
  );
}